const formatTime = (timeString, use24Hour = false) => {
  const language = localStorage.getItem('language') || 'en';
  const lang = language === 'fr' ? 'fr-FR' : language === 'ar' ? 'ar-MA' : 'en-US';

  if (!timeString) return '—';

  try {
    // Handle time-only strings like "02:25:15"
    const [hours, minutes, seconds] = timeString.split(":").map(Number);

    const date = new Date();
    date.setHours(hours, minutes, seconds || 0, 0);

    return date.toLocaleTimeString(lang, {
      hour12: !use24Hour,
      hour: '2-digit',
      minute: '2-digit'
    });
  } catch (error) {
   // Handle error silently
    return '—';
  }
};

export default formatTime;
